// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'd490d581873535973d6ab86777c6997556ef056c';
export const BUILD_NUMBER = '297';
export const BUILD_TIMESTAMP = '2026-11-04T05:01:20.117Z';
